<template>
  <section id="userIndex">
    <EvaluationForm
      v-if="formDialog"
      :dialogProp="formDialog"
      @dialog:close="closeDialog"
      :dataToForm="dataToForm"
      :mode="formMode"
    />
    <DeleteDialog
      v-if="deleteDialog"
      mode="evaluation"
      :dialogProp="deleteDialog"
      @dialog:close="closeDialog"
      :item="itemToDelete"
    />
    <EvaluationProcess
      v-if="processDialog"
      :processDialog="processDialog"
      :idEvaluation="idEvaluationToProcess"
      @dialog:close="toggleProcess()"
    />
    <v-container fluid>
      <v-row class="justify-between align-center">
        <v-col cols="12" md="auto">
          <v-btn
            class="accent shadow-4 px-8"
            large
            rounded
            @click.stop="openRegisterForm()"
            >Añadir Evaluacion</v-btn
          >
        </v-col>

        <v-col cols="12" md="auto" class="ml-auto">
          <v-text-field
            v-if="!isLoading"
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <v-skeleton-loader
        v-if="isLoading"
        type="table"
        class="pa-5"
        style="background: white"
      >
        <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
      </v-skeleton-loader>
      <v-data-table
        v-else
        :headers="headers"
        :items="Evaluations"
        :search="search"
        :items-per-page="itemsPerPage"
        hide-default-footer
        :page.sync="page"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
              </v-list-item-content>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.date`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="normalizeDate(item.date)"
                ></v-list-item-title>
              </v-list-item-content>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="text--darken-1 font-weight-medium"
                  v-html="normalizeDate(item.date)"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.process`]="{ item }">
          <v-list-item-content class="d-md-block ml-3">
            <v-btn
              class="accent shadow-4 px-8"
              rounded
              @click.stop="toggleProcess(item.id)"
              >Ver Procesos</v-btn
            >
          </v-list-item-content>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="editEvaluation(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'error' : 'blue-grey'"
              @click.stop="deleteEvaluation(item)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-card>
    <!-- PAGINATION -->
    <v-row justify="end">
      <v-col cols="auto">
        <v-pagination
          circle
          color="primary"
          v-model="page"
          :length="pageCount"
        ></v-pagination>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import moment from "moment";
import EvaluationForm from "@/components/Evaluations/EvaluationForm";
import DeleteDialog from "@/components/Utils/DeleteDialog";
import EvaluationProcess from "@/components/EvaluationProcess";

export default {
  components: {
    moment,
    DeleteDialog,
    EvaluationForm,
    EvaluationProcess,
  },
  data() {
    return {
      headers: [
        {
          text: "Evaluaciones",
          align: "left",
          sortable: true,
          value: "name",
          class: "primary--text",
          width: "40%",
        },
        {
          text: "Fecha",
          align: "left",
          sortable: true,
          value: "date",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Ver Procesos",
          align: "left",
          sortable: false,
          value: "process",
          class: "primary--text",
          width: "25%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      page: 1,
      pageCount: 0,
      totalItems: 0,
      itemsPerPage: 15,
      search: "",
      data: [],
      UserInfo: [],
      // Form
      formDialog: false,
      formMode: "register",
      dataToForm: null,

      //Delete Dialog
      deleteDialog: false,
      itemToDelete: null,

      //Process Dialog
      idEvaluationToProcess: null,
      processDialog: false,

      dialog: false,
      dialogTableVisible: false,
      clientInfo: "",
      updateActive: false,
      errorData: "",
      activeAlert: "",
      colorAlert: "",
      isLoading: false,
    };
  },
  created() {
    if (this.Evaluations.length <= 0) this.GetEvaluations();
    else this.pageCount = Math.ceil(this.Evaluations.length / this.itemsPerPage)
;
  },

  computed: {
    Evaluations() {
      return this.$store.getters["evaluations/GET_ALL_EVALUATIONS"];
    },
  },

  watch: {
    page(){ if(this.totalItems !== this.Evaluations.length)this.GetEvaluations()}
  },

  methods: {
    openRegisterForm() {
      this.formDialog = true;
      this.formMode = "register";
    },
    closeDialog() {
      this.formDialog = false;
      this.deleteDialog = false;
      this.itemToDelete = false;
      this.dataToForm = null;
    },
    editEvaluation(item) {
      this.formDialog = true;
      this.formMode = "edit";
      this.dataToForm = item;
    },
    deleteEvaluation(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },
    // Store
    async GetEvaluations() {
      this.isLoading = true;
      try {
        const response = await this.$store.dispatch(
          "evaluations/SHOW_EVALUATIONS", this.page
        );
        this.totalItems = response.total
        this.pageCount = Math.ceil(response.total / this.itemsPerPage)
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },

    //Process
    toggleProcess(id = false) {
      this.processDialog = !this.processDialog;
      if (id) this.idEvaluationToProcess = id;
    },

    normalizeDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
